import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Order } from 'src/app/models/order.model';

@Component({
    selector: 'order-list-display',
    templateUrl: './order-list-display.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [DatePipe, RouterLink],
})
export class OrderListDisplayComponent {
  @Input() order: Order;
  @Input() isSelected: boolean;
}
